<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>

    <table-filter
      :search="search"
      v-on:clearSearchParent="clearSearch"
      v-on:getDataParent="getData"
      :loading="loading"
    />
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :refresh-table="refeshTable"
      :customTopActions="true"
      item-key="id"
      table-height="70vh"
      @select-row="selectRow"
      @view-detail="viewDetail"
    >
    <template v-slot:top>
        <table-top-vue
          :loading="loading"
          :listButton="listButton"
          v-on:getDataParent="getData"
          v-on:addItemParent="addItem"
          v-on:exportItemParent="exportItem"
        />
      </template>
    <template slot="action" slot-scope="{ item }">
      <div class="d-flex justify-center align-center" style="height: 100%">
        <td class="d-block d-sm-table-cell d-print-table-cell">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
        :disabled="item.disabled_edit == 'true'"
      >
        mdi-pencil
      </v-icon>
      <v-icon small class="mr-2" @click="viewItem(item.id)">
        mdi-eye
      </v-icon>
    </td>
      </div>
    </template>
    </TableView>
    <v-dialog v-model="dialog" max-width="500px">
      <table-edit
        :editedItem="editedItem"
        :editedIndex="editedIndex"
        v-on:closeParent="close"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { date, showAlert } from '../../lib/helpers';
import { headers, search } from '../../components/user-management-merchant/attributes';

export default {
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TableTopVue: () => import('../../components/table/TableTop.vue'),
    TableFilter: () => import('../../components/table/UserMerchantFilter.vue'),
    TableEdit: () => import('../../components/table/UserMerchantEdit.vue'),
  },
  beforeMount() {
    const { type } = this.$route.params;
    if (type) {
      this.$route.meta.appBarTitle = `User Merchant Management - ${type} merchant`;
    }
  },
  data: () => ({
    listButton: {
      buttonRestart: true,
      buttonDots: true,
      buttonDotsExt: [
        {
          link: 'exportItemParent',
          show: true,
          icon: 'mdi-file-excel',
          title: 'Export to excel',
          voidStatus: true,
        },
      ],
    },
    isFirstLoad: true,
    options: {},
    view: false,
    dialog: false,
    headers,
    search,
    editedItem: { username: '' },
    selectedRow: '',
    editedIndex: -1,
  }),

  computed: {
    appBarType() {
      return this.$route.params.type;
    },
    allData() {
      return this.$store.state.userMerchant.allUsers;
    },
    detailData() {
      return this.$store.state.userMerchant.item;
    },
    totalData() {
      return this.$store.state.userMerchant.totalUsers;
    },
    totalPage() {
      return this.$store.state.userMerchant.totalPage;
    },
    loading() {
      return this.$store.state.userMerchant.loading;
    },

    flashError: {
      get() {
        return this.$store.state.userMerchant.flashError;
      },
      set() {
        this.$store.commit('userMerchant/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.userMerchant.flashErrorMessage;
    },
    allowSearch() {
      return this.search.createdDate.length >= 1;
    },
  },

  watch: {
    appBarType(val) {
      this.$route.meta.appBarTitle = `User Merchant Management - ${val} merchant`;
      this.clearSearch();
    },
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('userMerchant/clearUsers');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    getData() {
      if (!this.allowSearch) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'crated at is required !', 'mdi-alert', 'red');
        this.$store.commit('userMerchant/clearUsers');
      } else {
        this.$store.commit('userMerchant/setFlashErrorMessage', '');
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store
          .dispatch('userMerchant/fetchUsers', {
            date,
            page,
            itemsPerPage,
            sortBy,
            sortDesc,
            search: this.search,
            type: this.$route.params.type,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage == 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          });
      }
    },

    addItem() {
      this.$router.push({ path: '/userMerchant/add' });
    },

    async viewItem(itemId) {
      this.$router.push({
        path: `/user-management-merchant/${this.$route.params.type}/${itemId}`,
      });
    },

    async editItem(item) {
      this.view = false;
      const newItem = { ...item, id: item.id };
      this.editedIndex = this.$store.state.userMerchant.allUsers.indexOf(item);
      this.editedItem = { ...newItem };
      this.dialog = true;
    },

    close() {
      this.view = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeFlash() {
      this.$store.commit('userMerchant/setFlashErrorMessage', '');
    },

    clearSearch() {
      this.search.createdDate = [];
      this.search.merchantId = '';
      this.search.userRole = '';
      this.$nextTick(() => {
        this.$store.commit('userMerchant/clearUsers');
        this.$store.commit('userMerchant/clearMerchant');
      });
    },

    exportItem() {
      if (!this.allowSearch) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'crated at is required !', 'mdi-alert', 'red');
      } else {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store.dispatch('exportList', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          exportUrl: `api/v1/export/export-user-management-merchant/index&exportType=${this.$route.params.type}`,
          exportController: 'export-user-management-merchant',
          exportType:
            this.$route.params.type == 'portal'
              ? 'portalMerchant'
              : 'mobileMerchant',
        });
      }
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
